var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-cert-details"},[_c('img',{attrs:{"src":require("@/assets/logged-in-logo.svg"),"alt":"HD Lift Equipment"}}),_c('h2',[_vm._v("Certification Details")])])
}]

export { render, staticRenderFns }